module.exports = __webpack_public_path__ + "fonts/IstokWeb-Bold.e4222059.woff";